<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>车间看板</el-breadcrumb-item>
			<el-breadcrumb-item>查看设备</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item label="查询">
					<el-select v-model="workshop" placeholder="车间选择" :clearable="true">
						<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="search">查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table border v-loading="tableLoading" :data="tableData" :row-class-name="tableRowClassName" class="table-list">
			<el-table-column type="index" label="序号" width="55"></el-table-column>
			<el-table-column prop="workshop.name" label="车间" width="100" sortable :sort-method="sortWorkshopName"></el-table-column>
			<el-table-column label="设备名称" width="120" sortable :sort-method="sortJTName">
				<template slot-scope="scope">
					<el-button v-text="scope.row.name" type="text" @click="viewDevice(scope.row)" />
				</template>
			</el-table-column>
			<el-table-column resizable prop="productName" label="产品名称" sortable :sort-method="sortProductName"></el-table-column>
			<el-table-column prop="code" label="工单号" sortable :sort-method="sortOrderCode"></el-table-column>
			<el-table-column prop="yield_rate" :formatter="yieldRateFormatter" label="良品率" width="100" sortable></el-table-column>
			<el-table-column prop="status" label="机器状态" width="110" sortable>
				<template slot-scope="scope">
					<el-tag :type="getJTStatusTagType(scope.row.status)" v-text="scope.row.status_text"></el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="status_icw" label="检测状态" width="110" sortable>
				<template slot-scope="scope">
					<span v-text="scope.row.status_icw_text"></span>
				</template>
			</el-table-column>
			<el-table-column prop="startTime" label="开机时间" width="200" sortable></el-table-column>
			<el-table-column prop="remaining" label="剩余时间(分钟)" width="170" sortable></el-table-column>
			<el-table-column prop="progress" :formatter="progressFormatter" label="生产进度" width="120" sortable></el-table-column>
			<el-table-column label="工艺参数" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" @click="viewTechDetails(scope.row)">查看</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"></el-pagination>

		<!--工艺参数详情-->
		<TeachGroupDetailDialog :show="teachGroupDetailDialogVisible" :teachGroupId="selectedTeachGroupId" v-on:close="detailDialogClose" />
	</div>
</template>

<script>
	import TeachGroupDetailDialog from '@/views/public/TeachGroupDetailDialog'
	import jtService from '@/service/jtService'
	import dictionaryData from '@/service/dictionaryData'

	import moment from 'moment'
	export default {
		components: {
			TeachGroupDetailDialog,
		},
		data() {
			return {
				workshop: '',
				workshops: [],
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				tableData: [],
				tableLoading: false,
				teachGroupDetailDialogVisible: false,
				selectedTeachGroupId: '',
				loopInterval: null,
			}
		},
		computed: {},
		methods: {
			/**
			 * 良品率格式化。
			 */
			yieldRateFormatter(row, column, cellValue, index) {
				return cellValue + ' %'
			},
			/**
			 * 进度格式化。
			 */
			progressFormatter(row, column, cellValue, index) {
				return cellValue + ' %'
			},
			/**
			 * 表格行，高亮。
			 */
			tableRowClassName({ row, rowIndex }) {
				var p = row.progress

				if (row.remaining < 0 || p > 100) {
					return 'hightlight-row'
				}

				return ''
			},
			/**
			 * 工单排序。
			 */
			sortOrderCode(a, b) {
				if (a.workCode) return a.workCode.localeCompare(b.workCode, 'zh')

				return 0
			},
			/**
			 * 产品排序。
			 */
			sortProductName(a, b) {
				if (a.productName) return a.productName.localeCompare(b.productName, 'zh')

				return 0
			},
			/**
			 * 机台排序。
			 */
			sortJTName(a, b) {
				return a.name.localeCompare(b.name, 'zh')
			},
			/**
			 * 车间排序。
			 */
			sortWorkshopName(a, b) {
				return a.workshop.name.localeCompare(b.workshop.name, 'zh')
			},
			getFilter() {
				var filter = {
					jt_id: '',
					workshop_id: '',
				}

				if (this.workshop) {
					filter.workshop_id = this.workshop
				} else {
					filter = undefined
				}

				return filter
			},
			/**
			 * 查询设备。
			 */
			query() {
				clearInterval(this.loopInterval)
				var q = () => {
					var filter = this.getFilter()
					jtService.getDeviceStatusList(this.pageIndex, this.pageSize, filter).then(res => {
						this.tableData = res.data
						console.log('code', this.tableData)
						this.pageCount = res.pageCount
						this.tableLoading = false
					})
				}

				//10秒轮询。
				this.loopInterval = setInterval(() => {
					q()
				}, 10000)
			},
			/**
			 * 提交查询。
			 */
			search() {
				this.tableLoading = true
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 切换页码。
			 */
			currentChange(page) {
				this.tableLoading = true
				this.pageIndex = page
				this.query()
			},
			/**
			 * 每页记录数量切换。
			 */
			sizeChange(size) {
				this.tableLoading = true
				this.pageSize = size
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 关闭工艺参数详情查看功能。
			 */
			detailDialogClose() {
				this.teachGroupDetailDialogVisible = false
			},
			/**
			 * 查看工艺参数详情。
			 */
			viewTechDetails(row) {
				console.log(row)
				this.selectedTeachGroupId = row.tech_group_id
				this.teachGroupDetailDialogVisible = true
			},
			/**
			 * 获取机台运行状态的标签的类型。
			 */
			getJTStatusTagType(status) {
				var tagTypes = {
					0: 'danger',
					1: 'success',
				}
				if (!status) {
					return 'black'
				}

				if (tagTypes[status]) {
					return tagTypes[status]
				}

				return 'waring'
			},
			/**
			 * 查看详情。
			 */
			viewDevice(row) {
				this.$router.push({ name: 'WorkshopView', query: { jt_id: row.id }, replace: true })
			},
			dispose() {
				console.log('清空：loopInterval')
				clearInterval(this.loopInterval)
			},
		},
		destroyed() {
			this.dispose()
		},
		created() {
			this.tableLoading = true
			dictionaryData.getWorkshops().then(res => {
				this.workshops = res
			})

			this.query()
		},
	}
</script>
<style lang="less" scoped>
	.table-list {
		width: 100%;
		/deep/.hightlight-row {
			background-color: rgb(255 204 204);

			td {
				border-bottom-color: rgb(247 178 178);
			}
		}
	}
	.el-table--border td {
		border-right: 0 solid #e2e3e4;
	}
	.el-table td {
		border-bottom: 0 solid #e2e3e4;
	}
</style>
